/**
 * Sleeps via async so you can yield execution without busy-waiting. It's rare that
 * you'd need this in production; try refactoring your code to use setTimeout directly,
 * by putting the delayed logic in the callback.
 */
export const sleep = async (durationMs: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, durationMs);
  });
